import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { userinfoActions, alertActions } from '../../../store/actions'
import Pcc from '../../../module/cert/Pcc/PccV4'
import PccMobile from '../../../module/cert/Pcc/PccV4Mobile'
import * as common from '../../../assets/js/common.js'

const CrtfctStep03 = (props) => {
  const { auth } = props
  const [userInfo, setUserInfo] = useState({})
  const [isPccOpen, setIsPccOpen] = useState(false) // 본인인증popup open 여부
  const [certResult, setCertResult] = useState(false)

  useEffect(() => {
    auth?.isLoggedIn && setUserInfo(auth?.user?.payload)
  }, [])

  useEffect(() => {
    var timestamp = props.userInfo?.mobileCertDt
    var date = new Date(timestamp)
    var date1 = date.getFullYear() + 3 + '.' + (date.getMonth() + 1) + '.' + date.getDate()

    setUserInfo({
      ...userInfo,
      certCiYn: props.userInfo?.certCiYn,
      ewalletId: props.userInfo?.ewalletId,
      mobileCertDt: date1,
    })
  }, [props.userInfo])

  useEffect(() => {
    console.log('01', props)
    if (certResult) {
      console.log('02', props)
      props.updateEwalletId(props.cellNo, props.certCi, props.certDate)
      window.location.href = '/crtfct/mng?step=3'
    }
  }, [certResult])

  return (
    <React.Fragment>
      <h3 className="h3-tit mt20 pc-only">사설인증서 정보</h3>
      <div className="cert-gray-box">
        <div className="cert-info">
          <div className="box">
            <dl>
              <dt>인증서 정보</dt>
              <dd>유효기간 {userInfo.mobileCertDt}</dd>
            </dl>
          </div>
          <div className="d-flex">
            <a
              href="#"
              onClick={() => {
                setIsPccOpen(true)
              }}
              className="btn-primary lg full"
            >
              발급하기
            </a>
          </div>
        </div>
      </div>
      {common.getDeviceType() !== 'MobileApp' ? (
        <Pcc isPccOpen={isPccOpen} onChange={() => setIsPccOpen(false)} callBack={setCertResult} />
      ) : (
        <PccMobile isPccOpen={isPccOpen} onChange={() => setIsPccOpen(false)} callBack={setCertResult} />
      )}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    cellNo: state.certificate?.resultInfo?.cellNo,
    certDate: state.certificate?.resultInfo?.certDate,
    certCi: state.certificate?.resultInfo?.ci1,
    userInfo: state.userinfo?.data,
  }
}

const actionCreators = {
  load: userinfoActions.load,
  success: alertActions.success,
  error: alertActions.error,
  updateEwalletId: userinfoActions.updateEwalletId,
}

export default connect(mapStateToProps, actionCreators)(CrtfctStep03)
